import { render, staticRenderFns } from "./CookieConsent.vue?vue&type=template&id=4647e83e&scoped=true&"
import script from "./CookieConsent.vue?vue&type=script&lang=js&"
export * from "./CookieConsent.vue?vue&type=script&lang=js&"
import style0 from "./CookieConsent.vue?vue&type=style&index=0&id=4647e83e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4647e83e",
  null
  
)

export default component.exports